<template>
  <div @click.prevent="playVideo" :class="lessonActive === lesson._id ? 'active' : ''" class="list-2-container">
    <div class="left">

      <p :class="lessonActive === lesson._id ? 'th-font-weight-bold' : ''">{{lesson.name}}</p>
    </div>
    <!-- <div class="right"><p>{{lesson.duration ? lesson.duration : 'Akan Datang' }}</p></div> -->
    <div class="right">
      <template v-if="lessonActive === lesson._id">
        <PlayNowIcon theme="white" />
      </template>
      <template v-else-if="isFinishedLesson(lesson._id)">
        <FinishIcon />
      </template>
    </div>
  </div>
</template>

<script>
const FinishIcon = () => import('@/components/Icon/Finish')
const PlayNowIcon = () => import('@/components/Icon/PlayNow')
export default {
  props: {
    lesson: {
      type: Object,
      required: true,
    },
    lessonActive: {
      type: String,
      required: true,
    },
    lessonLogs: {
      type: Array,
      required: true,
    },
  },
  components: {
    FinishIcon,
    PlayNowIcon,
  },
  methods: {
    isFinishedLesson(key) {
      return Boolean(this.lessonLogs.find(lesson => lesson._id === key && lesson.status === 'finished'))
    },
    playVideo() {
      const payload = {
        first: false,
        selectedLesson: this.lesson,
      }
      this.$emit('play-video', payload)
    },
  },
}
</script>

<style lang="scss">
.list-2-container {
  margin-top: 14px;
  padding: 10px;
  height: 50px;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background: var(--kit-border);

  &.active {
    background: var(--kit-color-primary);
    color: white;
  }

  .left {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    width: 80%;

    p {
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
